const GemiusProductCard = () => {
  if (window?._gdeaq && Array.isArray(window._gdeaq)) {
    window._gdeaq.push(['pageView', 'gde-default', 'd6Xgks9I20_89ZIogiMkhLR5j_5_ORsgguWCt3MYvln.h7', 'my.adocean.pl', 'DnI7C5aSOJ_CzWNW44V3oJoY79NbVM8AU7SKZzgdcbT.T7']);
  }
};
export default GemiusProductCard;